import { render, staticRenderFns } from "./InfoTopRight.vue?vue&type=template&id=64af2f94&scoped=true&"
import script from "./InfoTopRight.vue?vue&type=script&lang=js&"
export * from "./InfoTopRight.vue?vue&type=script&lang=js&"
import style0 from "./InfoTopRight.vue?vue&type=style&index=0&id=64af2f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af2f94",
  null
  
)

export default component.exports